import Vue from 'vue'
import App from './common/layout/App.vue'
import './common/server/registerServiceWorker'
import router from './common/router/router'
import store from './store'
import "./common/style/index.scss"
import "./authorization/style/index.scss"
import "./visualization/style/timeline.scss"
import "./schedule/style/schedule.scss"
import {Translator} from "@/common/translator";
import {Server} from "@/common/server/server";
import '!style-loader!css-loader!vue2-datepicker/index.css';
import 'vue2-datepicker';
import 'vue2-datepicker/locale/pl';
import "./common/server/registerServiceWorker"
import {__BUILD_COMMIT_HASH__} from "../version";

(async function () {

    console.log('Version of frontend: ' + __BUILD_COMMIT_HASH__)

    function updateMeta() {
        const themeMeta = document.querySelector('meta[name="theme-color"]');
        if (themeMeta)
            themeMeta.content = getComputedStyle(document.documentElement).getPropertyValue('--background');
    }

    updateMeta();
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener('change', updateMeta);

    Vue.prototype.$t = Translator.translate.bind(Translator);

    Vue.config.productionTip = false

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
    store.dispatch("loadCommonData");
    if (window.cookieStore) {
        cookieStore.addEventListener('change', e => {
            if (e.changed.some(x => x.name == "updatedCommonData")) {
                store.dispatch("refreshCommonData");
            }
        })
    }

    let errorCounter = 0;
    addEventListener('error', e => {
        let obj = {
            source:'onErrorEvent'
        };
        for(const keyExtra in e) {
            try{
                obj['event_'+keyExtra]=JSON.parse(JSON.stringify(e[keyExtra]));
            }catch(_){}
        }
        for(const keyExtra of ['name','message','stack','couse','columnNumber','fileName','lineNumber' ]) {
            try{
                obj['error_'+keyExtra]=JSON.parse(JSON.stringify(e.error[keyExtra]));
            }catch(_){}
        }
        try{
            obj.stack2a=(new Error()).stack.toString()
        }catch (e) {

        } try{
            obj.event=e.toString()
        }catch (e) {

        }
        try{
            obj.error=e.error.toString()
        }catch (e) {

        }
        if (errorCounter++ < 25) {
            Server.TechnicalLog.SaveFrontendError(JSON.stringify(obj)).catch(() => {
            });
        }
        console.error(obj)
        store.commit('showNotification', {text: Translator.translate('common.error occurred'), type: 'error'});
    });
    addEventListener('unhandledrejection', e => {
        let obj = {
            source:'unhandledrejection',
            stack2b: (new Error()).stack
        };
        for(const keyExtra in e) {
            try{
                obj['event_'+keyExtra]=JSON.parse(JSON.stringify(e[keyExtra]));
            }catch(_){}
        }
        for(const keyExtra in e.reason??{}) {
            try{
                obj['reason_'+keyExtra]=JSON.parse(JSON.stringify(e.reason[keyExtra]));
            }catch(_){}
        }
        try{
            obj.event=e.toString()
        }catch (e) {

        }
        try{
            obj.reason=e.reason.toString()
        }catch (e) {

        }
        if (errorCounter++ < 25)
            Server.TechnicalLog.SaveFrontendError(JSON.stringify(obj)).catch(() => {
            });
        console.error(obj, e.reason)
        showException(e.reason);
    });

    Vue.config.errorHandler = function (ex, vm, info) {
        let obj = {
            message: ex.message,
            stack: ex.stack
        };
        if (errorCounter++ < 25)
            Server.TechnicalLog.SaveFrontendError(JSON.stringify(obj)).catch(() => {
            });
        console.error(obj, ex)
        showException(ex);
    }

    function showException(ex) {
        let text = 'common.error occurred';
        if (ex?.message == '403')
            text = 'common.access denied';
        if (ex?.userVisible)
            text = ex.message;
        store.commit('showNotification', {
            text: Translator.translate(text),
            type: 'error'
        });
    }

    const notInitiatedCards = new WeakSet();
    let stickyScrollbar = null;

    function updateTableSticky() {
        for (const table of document.querySelectorAll('table')) {
            table.style.setProperty('--stickyTop', Math.min(Math.max(0, -table.getBoundingClientRect().top), table.getBoundingClientRect().height) + 'px')

        }
        let stickyScrollbarUsed = false;
        for (const card of document.querySelectorAll('.card')) {

            card.style.setProperty('--stickyLeft', card.scrollLeft + 'px')
            if (!notInitiatedCards.has(card)) {
                card.addEventListener('scroll', updateTableSticky);
                notInitiatedCards.add(card)
            }
            if (card.getBoundingClientRect().bottom > innerHeight && card.getBoundingClientRect().top < innerHeight && card.scrollWidth > card.clientWidth) {
                stickyScrollbarUsed = true;
                if (!stickyScrollbar) {
                    stickyScrollbar = document.createElement('div');
                    stickyScrollbar.className = 'stickyScrollbar';
                    document.body.appendChild(stickyScrollbar);
                    stickyScrollbar.appendChild(document.createElement('div'));
                }
                stickyScrollbar.style.left = card.getBoundingClientRect().left + 'px';
                stickyScrollbar.style.width = card.getBoundingClientRect().width + 'px';
                stickyScrollbar.style.height = (stickyScrollbar.offsetHeight - stickyScrollbar.clientHeight + 1) + 'px';
                stickyScrollbar.firstChild.style.width = card.scrollWidth + 'px';
                stickyScrollbar.scrollLeft = card.scrollLeft;
                stickyScrollbar.onscroll = e => {
                    card.scrollLeft = stickyScrollbar.scrollLeft;
                }
            }
        }
        if (!stickyScrollbarUsed && stickyScrollbar) {
            stickyScrollbar.remove();
            stickyScrollbar = null;
        }
    }

    document.addEventListener('scroll', updateTableSticky);
    addEventListener('resize', updateTableSticky);

})()
